import Vue from 'vue'

Vue.directive('dialogDrag', {
    bind(el, binding, vnode, oldVnode) {

        // 初始化宽高
        const Width = 1400
        const Height = 700

        // 最小宽高
        const minWidth = 500
        const minHeight = 300
        // 窗体头部
        const dialogHeaderEl = el.querySelector('.el-dialog__header')
        // 整个窗体
        const dragDom = el.querySelector('.el-dialog')

        dragDom.style.width = Width + 'px'
        dragDom.style.height = Height + 'px'

        dialogHeaderEl.style.cssText += ';cursor:move;'
        dragDom.style.cssText += ';top:0;left:0;'

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = (() => {
            if (window.document.currentStyle) {
                return (dom, attr) => dom.currentStyle[attr]
            } else {
                return (dom, attr) => getComputedStyle(dom, false)[attr]
            }
        })()

        dialogHeaderEl.onmousedown = (e) => {
            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - dialogHeaderEl.offsetLeft
            const dixY = e.clientY - dialogHeaderEl.offsetTop

            const screenWidth = document.body.clientWidth // body当前宽度
            const screenHeight = document.documentElement.clientHeight // 可见区域高度(应为body高度，可某些环境下无法获取)

            const dragDomWidth = dragDom.offsetWidth // 对话框宽度
            const dragDomheight = dragDom.offsetHeight // 对话框高度

            const minDragDomLeft = dragDom.offsetLeft
            const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth
            const minDragDomTop = dragDom.offsetTop
            const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight

            // 获取到的值带px 正则匹配替换
            let styL = sty(dragDom, 'left')
            let styT = sty(dragDom, 'top')

            // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
            if (styL.includes('%')) {
                styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100)
                styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100)
            } else {
                styL = +styL.replace(/\px/g, '')
                styT = +styT.replace(/\px/g, '')
            }

            document.onmousemove = function (e) {
                // 通过事件委托计算移动的距离
                let left = e.clientX - disX

                let top = e.clientY - dixY

                // 边界处理
                if (maxDragDomLeft > 0) {
                    if (-left > minDragDomLeft) {
                        left = -minDragDomLeft
                    } else if (left > maxDragDomLeft) {
                        left = maxDragDomLeft
                    }
                } else {
                    if (-left > minDragDomLeft) {
                        left = -minDragDomLeft
                    }
                    // if (left < 0) {
                    //   left = 0
                    // }
                }

                if (maxDragDomTop > 0) {
                    if (-top > minDragDomTop) {
                        top = -minDragDomTop
                    } else if (top > maxDragDomTop) {
                        top = maxDragDomTop
                    }
                } else {
                    if (-top > minDragDomTop) {
                        top = -minDragDomTop
                    }
                    // if (top > 0) {
                    //   top = 0
                    // }
                }

                dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`
            }
            document.onmouseup = function (e) {
                document.onmousemove = null
                document.onmouseup = null
            }

        }

        // 拉伸(右下方)
        let resizeEl = document.createElement('div')
        dragDom.appendChild(resizeEl)
        // 在弹窗右下角加上一个10-10px的控制块
        resizeEl.style.cursor = 'se-resize'
        resizeEl.style.position = 'absolute'
        resizeEl.style.height = '20px'
        resizeEl.style.width = '20px'
        resizeEl.style.right = '0px'
        resizeEl.style.bottom = '0px'
        resizeEl.style.zIndex = '99'
        let img = document.createElement('img')
        img.src = require('../assets/image/jb.png')
        img.style.position = 'absolute'
        img.style.height = '20px'
        img.style.width = '20px'
        img.style.right = '0px'
        img.style.bottom = '0px'
        img.style.zIndex = '99'
        resizeEl.appendChild(img)
        // 鼠标拉伸弹窗
        resizeEl.onmousedown = (e) => {
            // 记录初始x位置
            let clientX = e.clientX
            // 鼠标按下，计算当前元素距离可视区的距离
            let disX = e.clientX - resizeEl.offsetLeft
            let disY = e.clientY - resizeEl.offsetTop
            //   console.log(resizeEl.offsetLeft)
            document.onmousemove = function (e) {
                e.preventDefault() // 移动时禁用默认事件
                // 通过事件委托，计算移动的距离
                let x = e.clientX - disX + (e.clientX - clientX) // 这里 由于elementUI的dialog控制居中的，所以水平拉伸效果是双倍
                let y = e.clientY - disY
                // 比较是否小于最小宽高
                dragDom.style.width = x > minWidth ? `${x}px` : minWidth + 'px'
                dragDom.style.height = y > minHeight ? `${y}px` : minHeight + 'px'
                // if (typeof binding.value.changeSize === 'function') {
                //     binding.value.changeSize()
                // }
            }
            // 拉伸结束
            document.onmouseup = function (e) {
                document.onmousemove = null
                document.onmouseup = null
            }
        }
    }
})
